import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { IPagedResult } from '../../shared/models/paged-result';
import { IBank } from '../../shared/models/core/bank';

export const bankApi = createApi({
  reducerPath: 'bankApi',
  baseQuery,
  endpoints: (builder) => ({
    getBanks: builder.query<IPagedResult<IBank>, string | void>({
      query: (filterSet) => ({
        url: `/api/banks${filterSet ? `?${filterSet}` : ''}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetBanksQuery, useLazyGetBanksQuery } = bankApi;
